import React, { useState, useEffect } from 'react';
import { Menu, X, Sparkles } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';
import { translations } from '../data/mock';

export const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const { language, toggleLanguage } = useLanguage();
  const t = translations[language];

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      const offset = 100; // Jarak dari top
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;
      
      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
      setIsMobileMenuOpen(false);
    }
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        isScrolled
          ? 'bg-white/80 backdrop-blur-xl shadow-lg'
          : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <div className="flex items-center space-x-2 cursor-pointer" onClick={() => scrollToSection('home')}>
            <Sparkles className="w-8 h-8 text-blue-500" />
            <span className="text-xl sm:text-2xl font-black bg-gradient-to-r from-blue-500 to-purple-600 bg-clip-text text-transparent">
              Bahtera Lima Utama
            </span>
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-8">
            {Object.keys(t.nav).map((key) => (
              <button
                key={key}
                onClick={() => scrollToSection(key)}
                className={`text-sm font-medium transition-all duration-300 hover:text-blue-500 ${
                  isScrolled ? 'text-slate-800' : 'text-white'
                }`}
              >
                {t.nav[key]}
              </button>
            ))}
            
            {/* Language Toggle */}
            <div className="flex items-center space-x-2 border-l pl-4">
              <button
                onClick={toggleLanguage}
                className={`px-3 py-1 rounded-full text-sm font-medium transition-all duration-300 ${
                  language === 'en'
                    ? 'bg-blue-500 text-white'
                    : isScrolled
                    ? 'bg-slate-100 text-slate-600'
                    : 'bg-white/20 text-white'
                }`}
              >
                EN
              </button>
              <button
                onClick={toggleLanguage}
                className={`px-3 py-1 rounded-full text-sm font-medium transition-all duration-300 ${
                  language === 'id'
                    ? 'bg-blue-500 text-white'
                    : isScrolled
                    ? 'bg-slate-100 text-slate-600'
                    : 'bg-white/20 text-white'
                }`}
              >
                ID
              </button>
            </div>
          </nav>

          {/* Mobile Menu Button */}
          <div className="md:hidden flex items-center space-x-3">
            {/* Mobile Language Toggle */}
            <button
              onClick={toggleLanguage}
              className="px-3 py-1 rounded-full text-sm font-medium bg-blue-500 text-white"
            >
              {language.toUpperCase()}
            </button>
            <button
              onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
              className={`p-2 rounded-lg transition-colors ${
                isScrolled ? 'text-slate-800' : 'text-white'
              }`}
            >
              {isMobileMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
            </button>
          </div>
        </div>

        {/* Mobile Menu */}
        {isMobileMenuOpen && (
          <div className="md:hidden bg-white/95 backdrop-blur-xl border-t shadow-lg">
            <nav className="flex flex-col p-4">
              {Object.keys(t.nav).map((key) => (
                <button
                  key={key}
                  onClick={() => scrollToSection(key)}
                  className="text-left px-4 py-3 text-slate-800 font-medium hover:bg-blue-50 rounded-lg transition-colors"
                >
                  {t.nav[key]}
                </button>
              ))}
            </nav>
          </div>
        )}
      </div>
    </header>
  );
};
